module.exports = __webpack_public_path__ + "img/bj-blackberry.77bbe229.gif";